import ManageModel from './manageModel'

export default ManageModel
